import {ProjectSettings} from "./settings/ProjectSettings";
import {ResourceManagement} from "./resource-management/ResourceManagement";
import {FineTuning} from "./fine-tuning/FineTuning";
import {AsriPage} from "./asri/AsriPage";
import {SipPage} from "./sip/SipPage";
import {VocabularyPage} from "./vocabulary/vocabulary-page";
import {ProjectConfiguration} from "./configuration/ProjectConfiguration";
import {HealthCheckMonitoring} from "./health-check-monitoring/health-check-monitoring";
import {SupervisionPage} from "./supervision-page/supervision-page";
import {ProjectDashboard} from "./dashboard/ProjectDashboard";
import {Project} from "./flow/Project";
import {ProjectMembersPage} from "./members/project-members-page";
import {Neo4jPage} from "./neo4j/neo4j-page";
import {MessageAnnotationsPage} from "./message-annotation/message-annotations-page";
import {KnowledgeBasePage} from "./knowledge-base/knowledge-base-page";
import MCPDiscoveryPage from "./mcp-discovery/MCPDiscoveryPage";
import MCPServerDetailPage from "./mcp-discovery/MCPServerDetailPage";
import {KnowledgeManagerPage} from "./knowledge-manager/KnowledgeManagerPage"
import {KnowledgeManagerGeneralSettingsPage} from "./knowledge-manager/KnowledgeManagerGeneralSettingsPage"
import {KnowledgeManagerTopicDetailsPage} from "./knowledge-manager/KnowledgeManagerTopicDetails"

export const projectRoutes = [
  {
    path: "settings",
    element: ProjectSettings,
    roles: ["ADMIN", "MANAGER"],
  },
  {
    path: "resource-management/*",
    element: ResourceManagement,
    roles: ["ADMIN", "MANAGER"],
    desktopOnly: true
  },
  {
    path: "fine-tuning/:modelId/*",
    element: FineTuning,
    roles: ["ADMIN", "MANAGER"],
    desktopOnly: true
  },
  {
    path: "fine-tuning/*",
    element: FineTuning,
    roles: ["ADMIN", "MANAGER"],
    desktopOnly: true
  },
  {
    path: "asri",
    element: AsriPage,
    roles: ["ADMIN"],
    desktopOnly: true
  },
  {
    path: "sip",
    element: SipPage,
    roles: ["ADMIN"],
    desktopOnly: true
  },
  {
    path: "vocabulary",
    element: VocabularyPage,
    roles: ["ADMIN", "MANAGER", "AGENT", "ANNOTATOR"],
    desktopOnly: true
  },
  {
    path: "message-annotations",
    element: MessageAnnotationsPage,
    roles: ["ADMIN", "MANAGER", "AGENT", "ANNOTATOR"],
    desktopOnly: true
  },
  {
    path: "configuration",
    element: ProjectConfiguration,
    roles: ["ADMIN", "MANAGER"]
  },
  {
    path: "healthcheck",
    element: HealthCheckMonitoring,
    roles: ["ADMIN"]
  },
  {
    path: "members",
    element: ProjectMembersPage,
    roles: ["ADMIN", "MANAGER"]
  },
  {
    path: "flow/:flowId",
    element: Project,
    roles: ["ADMIN", "MANAGER"],
    desktopOnly: true
  },
  {
    path: "flow",
    element: Project,
    roles: ["ADMIN", "MANAGER"],
    desktopOnly: true
  },
  {
    path: "supervision",
    element: SupervisionPage,
    roles: ["ADMIN", "MANAGER", "AGENT", "ANNOTATOR"],
    desktopOnly: true
  },
  {
    path: "neo4j",
    element: Neo4jPage,
    roles: ["ADMIN", "MANAGER"],
    desktopOnly: true
  },
  {
    path: "supervision/:conversationId",
    element: SupervisionPage,
    roles: ["ADMIN", "MANAGER", "AGENT", "ANNOTATOR"],
    desktopOnly: true
  },
  {
    path: "",
    element: ProjectDashboard,
    roles: ["ADMIN", "MANAGER", "AGENT", "ANNOTATOR"]
  },
  {
    path: "mcp-registry",
    element: MCPDiscoveryPage,
    roles: ["ADMIN"],
    desktopOnly: true
  },
  {
    path: "mcp-registry/:serverId",
    element: MCPServerDetailPage,
    roles: ["ADMIN"],
    desktopOnly: true
  },
  {
    path:"knowledge-manager",
    element:KnowledgeManagerPage,
    roles: ["ADMIN"]
  },
  {
    path:"knowledge-manager/general-settings",
    element:KnowledgeManagerGeneralSettingsPage,
    roles: ["ADMIN"],
    desktopOnly: true
  },
  {
    path:"knowledge-manager/:topicId",
    element:KnowledgeManagerTopicDetailsPage,
    roles: ["ADMIN"],
    desktopOnly: true
  }
];
